import React from 'react';
import { encodeImageUrl } from '../../../helper/urlHelper';
import { constants } from '../../../constants';
import { Image } from './style';

interface Props {
  largeImageSrc: string;
  smallImageSrc: string;
  preserveImageWidth: boolean;
  mediaHeight: string;
  alternateDescription: string;
}

const ImageComponent = ({
  largeImageSrc,
  smallImageSrc,
  preserveImageWidth,
  mediaHeight,
  alternateDescription,
}: Props) => {
  const largeSrc = encodeImageUrl(largeImageSrc) || encodeImageUrl(smallImageSrc);

  const smallSrc = encodeImageUrl(smallImageSrc) || encodeImageUrl(largeImageSrc);

  const dprSet = (baseUrl: string, width: number) =>
    `${baseUrl}?width=${width} 1x, ${baseUrl}?width=${width * 2} 2x`;
  return (
    <picture>
      <source
        media={`(min-width:${constants.displaySizes.largeDesktop})`}
        sizes="1920px"
        srcSet={dprSet(largeSrc, 1920)}
      />

      <source
        media={`(min-width:${constants.displaySizes.desktop})`}
        sizes="1440px"
        srcSet={dprSet(largeSrc, 1440)}
      />

      <source
        media={`(min-width:${constants.displaySizes.smallDesktop})`}
        sizes="1024px"
        srcSet={dprSet(largeSrc, 1024)}
      />

      <source
        media={`(min-width:${constants.displaySizes.tablet})`}
        sizes="768px"
        srcSet={dprSet(smallSrc, 768)}
      />

      <source
        media="(max-width: 767px)"
        sizes="(max-width: 767px) 100vw"
        srcSet={dprSet(smallSrc, 576)}
      />

      <Image
        src={`${smallSrc}?width=576`}
        srcSet={dprSet(smallSrc, 576)}
        sizes="100vw"
        alt={alternateDescription}
        data-testid="carouselItemImage"
        className="img"
        loading="lazy"
        preserveImageWidth={preserveImageWidth}
        mediaHeight={mediaHeight}
      />
    </picture>
  );
};

export default ImageComponent;
